export enum ProfileRouteEnum {
  CABINET = 'cabinet',
  ADDUSER = 'add-user',
  MYPRIZE = 'my-prize',
  MYPRIZE_CREATE = 'my-prize-create',
  MYPRIZE_VIEW = 'my-prize-view',
  ADD_USER_CRUD = 'add-user-crud',
  INVITATION_DETAILS = 'invitation-details',
}
